<template>
  <div :class="['content', {'zh-style': language === 'zh'}]">
    <empty-reminder v-show="records.length == 0 && !loading"></empty-reminder>

    <div class="pc-records" v-if="records.length > 0">
      <div class="little-title">
        <p class="time">{{ $t('time') }}</p>
        <p class="description">{{ $t('description') }}</p>
      </div>
      <div class="records" v-for="record in records">
        <p class="time">{{ record.created_at | createFormatTime(record.created_at) }}</p>
        <p class="description"><span>{{ getDescription(record.nickname, record.status) }}</span></p>
      </div>
    </div>

    <div id="pager-bar" v-if="records.length > 0">
      <div class="spinner-component-box"><spinner :show="loading"></spinner></div>
      <pager :totalPage="totalPage" :init-page="currentPage" mode="event" @go-page="getFriendRecords"></pager>
    </div>
  </div>
</template>

<script>
  import {createFormatTime} from 'src/lib/filters'
  import locales from './lang'
  import EmptyReminder from '../EmptyReminder.vue'
  import Spinner from '../../Spinner.vue'
  import Pager from '../../pager/Index.vue'

  export default {
    name: 'friend-records-pc',
    components: {EmptyReminder, Spinner, Pager},
    props: ['initInvitationRecordsData'],
    data() {
      return {
        records: [],
        loading: false,
        totalPage: 0,
        currentPage: 0
      }
    },
    locales,
    computed: {
      language() {
        return this.$store.state.currentLang
      }
    },
    watch: {
      initInvitationRecordsData() {
        this.records = this.initInvitationRecordsData.data
        this.totalPage = Math.ceil(this.initInvitationRecordsData.meta['total'] / this.initInvitationRecordsData.meta['per_page'])
        this.currentPage = this.initInvitationRecordsData.meta['current_page']
      }
    },
    methods: {
      getFriendRecords(data) {
        this.loading = true
        this.$http.get('api/invitation-records', {params: {'page': data.page}}).then(response => {
          this.loading = false
          this.records = response.data.data
          this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
          this.currentPage = response.data.meta['current_page']
        }, (response) => {
          this.loading = false
        })
      },
      getDescription(nickname, status) {
        if (status === 'registered') {
          return this.$t('user') + nickname + this.$t('register')
        } else {
          return this.$t('user') + nickname + this.$t('recharge')
        }
      }
    },
    filters: {createFormatTime}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  .content {
    min-height: 2.16rem;
  }

  .pc-records {
    min-height: 4.5rem;
  }

  .little-title {
    line-height: .2rem;
    padding: .17rem 0;
    font-size: 0;
    color: #333333;
    font-weight: 600;
    letter-spacing: 0;
    border-bottom: .01rem solid #E0D7E3;
    display: flex;
  }

  .records {
    line-height: .2rem;
    padding: .17rem 0;
    font-size: 0;
    color: #666;
    letter-spacing: 0;
    border-bottom: .01rem solid #E0D7E3;
    display: flex;
  }

  p {
    display: inline-block;
    font-size: .14rem;
    letter-spacing: 0;
    &.time {
      flex-basis: 25%;
      text-align: center;

    }
    &.description {
      text-align: center;
      flex-basis: 75%;
      padding: 0 .2rem;
      span {
        display: inline-block;
        text-align: center;
        width: 100%;
      }
    }
  }

  @mixin zh-style() {
    p.description span {
      @media screen and (min-width: 812px) {
        width: 4.4rem;
      }
    }
  }
  .zh-style {
    @include zh-style();
  }

  #pager-bar {
    padding-bottom: .4rem;
    text-align: center;
    .spinner-component-box {
      min-height: .8rem;
      padding: .1rem 0;
    }
  }
</style>



// WEBPACK FOOTER //
// FriendRecordsPc.vue?9b93c8c0